{
  "title": "Nhật ký điều trị",
  "quantityVisits": "{{count}} lần",
  "quantityMinutes": "{{count}} phút",
  "clinicRequired": "Chọn phòng khám để xem bảng việc.",
  "month": "Tháng",
  "clinic": "Phòng khám",
  "searchPlaceholder": "Tìm việc, bệnh nhân hoặc nhân viên…",
  "lockedBadge": "Đã khóa",
  "lock": "Khóa tháng",
  "unlock": "Mở khóa",
  "lockSuccess": "Đã khóa bảng việc tháng này.",
  "unlockSuccess": "Đã mở khóa bảng việc.",
  "lockFailed": "Không khóa được bảng việc.",
  "unlockFailed": "Không mở khóa được bảng việc.",
  "loadFailed": "Không tải được bảng việc.",
  "unlockTitle": "Mở khóa bảng việc",
  "unlockHint": "Nhập lý do mở khóa. Không mở được nếu kỳ lương đã duyệt/khóa hoặc KPI clinic tháng này đã chốt và có phiếu lương.",
  "unlockReason": "Lý do mở khóa",
  "unlockConfirm": "Mở khóa",
  "cancel": "Hủy",
  "tabsAria": "Chế độ xem bảng việc",
  "tabs": {
    "entries": "Bảng tổng hợp",
    "doctors": "Theo bác sĩ",
    "assistants": "Theo phụ tá"
  },
  "filterStaff": "Việc của {{name}}",
  "filterWork": "Việc {{name}}",
  "emptyEntries": "Chưa có việc đếm trong tháng này.",
  "emptyDoctors": "Tháng này chưa có việc ghi nhận cho bác sĩ.",
  "emptyAssistants": "Tháng này chưa có việc ghi nhận cho phụ tá.",
  "emptyFiltered": "Không có việc khớp bộ lọc.",
  "permissionDenied": "Bạn không có quyền xem bảng việc.",
  "journal": {
    "title": "Nhật ký điều trị",
    "month": "Tháng",
    "permissionDenied": "Bạn không có quyền xem nhật ký điều trị của mình.",
    "loadFailed": "Không tải được nhật ký điều trị.",
    "empty": "Tháng này chưa có việc ghi nhận.",
    "roles": {
      "performer": "Người làm",
      "supporter": "Phụ tá",
      "inner": "Phụ tá vòng trong",
      "outer": "Phụ tá vòng ngoài"
    }
  },
  "fields": {
    "performedAt": "Ngày",
    "service": "Việc",
    "patient": "Bệnh nhân",
    "performers": "Người làm",
    "supporters": "Phụ tá",
    "staff": "Nhân viên",
    "performed": "Việc",
    "total": "Tổng",
    "totalMinutes": "Tổng phút",
    "quantity": "Khối lượng",
    "clinic": "Phòng khám",
    "journal": "Nhật ký",
    "role": "Vai trò",
    "supported": "Hỗ trợ",
    "supportedInner": "Vòng trong",
    "supportedOuter": "Vòng ngoài",
    "createdBy": "Người tạo",
    "updatedBy": "Người cập nhật",
    "createdAt": "Ngày tạo",
    "updatedAt": "Ngày chỉnh sửa"
  },
  "assistantPrefix": "PT.",
  "rings": {
    "inner": "Vòng trong",
    "outer": "Vòng ngoài"
  },
  "errors": {
    "WORK_TIMESHEET_MONTH_LOCKED": "Tháng bảng việc đã khóa. Không ghi buổi điều trị vào tháng này.",
    "WORK_TIMESHEET_MONTH_NOT_LOCKED": "Tháng bảng việc chưa khóa.",
    "WORK_TIMESHEET_IN_PAYROLL": "Không mở khóa vì kỳ lương phòng khám này đã duyệt hoặc khóa.",
    "WORK_TIMESHEET_IN_KPI_PAYROLL": "Không mở khóa vì kỳ KPI đã chốt và đã ghi vào phiếu lương.",
    "UNLOCK_REASON_REQUIRED": "Nhập lý do mở khóa.",
    "INVALID_MONTH": "Tháng phải dạng YYYY-MM."
  }
}
